import { render, staticRenderFns } from "./yeardata.vue?vue&type=template&id=410a5df0&scoped=true&"
import script from "./yeardata.vue?vue&type=script&lang=js&"
export * from "./yeardata.vue?vue&type=script&lang=js&"
import style0 from "./yeardata.vue?vue&type=style&index=0&id=410a5df0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410a5df0",
  null
  
)

export default component.exports